<template lang="pug">
.wrapper
  .page-header.clear-filter
    .rellax-header.rellax-header-sky
      .page-header-image(style="background-image: url('img/asia.jpg')")
    .rellax-text-container.rellax-text
      h1.h1-seo(data-rellax-speed='0')  Asia Alternatives
    .subtext
      h3.h3-description.rellax-text(data-rellax-speed='-2') Private Equity
</template>
<script>
import { mapState } from 'vuex';
  export default {
    name: 'home',
    bodyClass: 'presentation-page',
    computed: {
        ...mapState({
            username: 'user'
            })
            },
  data() {
    return {
      }
      },
      created () {
      },
      methods: {
      showSignUp: function() {
      console.log('Request Access Modal')
      }
  }
  }
</script>
<style>
body.presentation-page  {
}

.presentation-page #app .page-header-city, .index-page .page-header-city {
top: 15.5%;
}

body.presentation-page .h3-description.rellax-text {
font-size: 2.5em;
}

body.presentation-page #app .rellax-text-container, .index-page .rellax-text-container {
    top: 150px;
    }
.presentation-page #app .rellax-text-container .h1-seo, #app .index-page .rellax-text-container .h1-seo {
    text-transform: lowercase;
    background: #19405c;
    -webkit-text-stroke: 1px #d6cfcf
}

.presentation-page #app .subtext .h3-description, .index-page .h3-description {
    display: inline-block;
    position: relative;
    margin-top: 100px;
    /*background-color: rgba(50,0,0,0.2);*/
    padding: 10px 12px;
    border-radius: 50px;
    opacity: 1;
    -webkit-transition: opacity 0.5s;
    transition: opacity 0.5s;
    width: auto;
    text-align: center;
    /*box-shadow: 0 5px 35px 0 rgba(0,0,0,.3);
    text-shadow: -5px 0px 20px rgba(50, 0, 0, 0.5), 5px 0px 20px rgba(50, 0, 0, 0.5), 0 -5px 20px rgba(50, 0, 0, 0.5), 0 5px 20px rgba(50, 0, 0, 0.5);*/
}
.presentation-page #app.scrolled .h3-description {
opacity: 0;
}

#app .subtext {
width: 100%;
text-align: center;
}
#app .rellax-text-container {
opacity: 1;
transition: opacity 0.75s;
}
#app.scrolled .rellax-text-container {
opacity: 0;
}

.signUp {
position: relative;
    z-index: 10;
        text-align: center;
            width: 100%;
                margin-top: -20px;
transition: opacity 0.75s;
                }

.presentation-page #app.scrolled .signUp {
opacity: 0;
}
.presentation-page #app .signUp a.btn.btn-primary {
    width: 100px;
    display: inline-block;
    height: 46px;
    color: white;
    border: 2px solid rgba(255,255,255,1);
    padding: 9px 0px;
    top: 50%;
    border-radius: 50px;
}
.presentation-page #app .signUp a:active, .presentation-page #app .signUp a:hover {
    border: 2px solid rgb(255,255,255);
    }
    .index-page .page-header, .presentation-page .page-header {
        height: 100vh;
        }
</style>
